module.exports = __webpack_public_path__ + "static/media/Radys.5d4b3d5d.png";